export default __webpack_public_path__ + "static/B37-7696e3d5e7b6aa6159065511a038a679.png";